import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import * as React from 'react';
import Button from './Button';
import ButtonSecondary from './ButtonSecondary';

export default function ConfirmDeleteInvoiceModal({ 
    open, 
    onClose, 
    onConfirm,
    isLoading = false
}) {
    return (
        <React.Fragment>
            <Dialog
                open={open}
                onClose={isLoading ? undefined : onClose}
                aria-labelledby="delete-invoice-dialog-title"
                aria-describedby="delete-invoice-dialog-description"
            >
                <DialogTitle 
                    id="delete-invoice-dialog-title"
                    style={{ 
                        fontFamily: 'Poppins, sans-serif',
                        fontWeight: 600,
                        fontSize: '18px'
                    }}
                >
                    Delete Invoice
                </DialogTitle>
                <DialogContent>
                    <DialogContentText 
                        id="delete-invoice-dialog-description"
                        style={{ 
                            fontFamily: 'Poppins, sans-serif',
                            fontSize: '14px',
                            color: '#3E3E4A'
                        }}
                    >
                        Are you sure you want to delete this invoice? This action cannot be undone.
                    </DialogContentText>
                </DialogContent>
                <DialogActions style={{ padding: '16px 24px', display: 'flex', gap: '8px', justifyContent: 'flex-end' }}>
                    <ButtonSecondary 
                        onClick={isLoading ? undefined : onClose}
                    >
                        Cancel
                    </ButtonSecondary>
                    <Button 
                        onClick={onConfirm}
                        disabled={isLoading}
                    >
                        {isLoading ? 'Deleting...' : 'Delete Invoice'}
                    </Button>
                </DialogActions>
            </Dialog>
        </React.Fragment>
    );
}
